module.exports = __webpack_public_path__ + "static/img/about-bulb-lower.2ed6332.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/about-bulb-lower.png
// module id = 42
// module chunks = 0